var map = {
	"./carouselForItemDetailsConstants.js": 73,
	"./carsouselForAvatarPageConstants.js": 74,
	"./carsouselForInventoryConstants.js": 75,
	"./itemListConstants.js": 76,
	"./recommendationsConstants.js": 77
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;